import {  PlantCapacityDto, ResourceOperationEfficiencyDto } from "@gtpl/shared-models/planning";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllPlantCapacityResponse extends GlobalResponseObject {
    data?: PlantCapacityDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: PlantCapacityDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

